import WMIcon from './WMIcon';

/**
 * BottomTabBar — mobile-only bottom navigation bar.
 * Hidden on md+ screens via Tailwind responsive utilities.
 *
 * Props:
 *   currentView — the active view key string
 *   onNavigate(key) — navigate to a view
 */

const TABS = [
  { key: 'dashboard', label: 'Home',   icon: 'chart-bar' },
  { key: 'estimates', label: 'Quotes', icon: 'document' },
  { key: 'orders',    label: 'Jobs',   icon: 'wrench' },
  { key: 'leadhub',  label: 'Leads',  icon: 'users' },
  { key: '__more__', label: 'More',   icon: 'squares-2x2' },
];

const SALES_VIEWS   = ['estimates', 'invoices'];
const OPS_VIEWS     = ['workflow', 'orders', 'scheduling'];
const CUSTOMER_VIEWS = ['leadhub', 'lists-customers', 'lists-vehicles', 'lists-manufacturers'];

function resolveActive(currentView, tabKey) {
  if (tabKey === '__more__') {
    return !['dashboard', ...SALES_VIEWS, ...OPS_VIEWS, ...CUSTOMER_VIEWS].includes(currentView);
  }
  if (tabKey === 'estimates') return SALES_VIEWS.includes(currentView);
  if (tabKey === 'orders')    return OPS_VIEWS.includes(currentView);
  if (tabKey === 'leadhub')  return CUSTOMER_VIEWS.includes(currentView);
  return currentView === tabKey;
}

export default function BottomTabBar({ currentView, onNavigate }) {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-[#0F1923] border-t border-gray-200 dark:border-[#243348] safe-area-pb">
      <div className="flex items-stretch h-14">
        {TABS.map(tab => {
          const active = resolveActive(currentView, tab.key);
          return (
            <button
              key={tab.key}
              onClick={() => {
                if (tab.key !== '__more__') onNavigate(tab.key);
                else onNavigate('settings'); // More → settings for now
              }}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors
                ${active
                  ? 'text-[#2E8BF0]'
                  : 'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300'
                }`}
            >
              <WMIcon name={tab.icon} className="w-5 h-5" />
              <span className={`text-[var(--wm-text-caption)] font-medium ${active ? 'text-[#2E8BF0]' : ''}`}>
                {tab.label}
              </span>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 bg-[#2E8BF0] rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
